import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import SelectFix from './_SelectFix';
import PopUpOther from './_PopUpOther';
import DataConfig from './../_config.json';
import { OnGetJson } from '../_getjson';
import { AlertPopup } from './../PopUp/AlertPopup';
import PopUpItem from './../PopUp/PopUpItem';

export default class _tab_5 extends React.Component {
    state = {
        tableproducts: [],
        rowTable: "30",
        typeset: "",
        searchProduct: "",
        searchProducttoDB: "",
        //***********chkclick************* */
        rowChk: "",
        colChk: "",
    }
    setRow = (count) => {
        var data = [];
        for (var i = 0; i <= count - 1; i++) {
            data[i] = {
                C0: i + 1,
                C1: "",
                C2: "",
                C3: "",
                C4: "",
                C5: "",
                C6: "",
                C7: "",
            }

        }
        this.setState({ tableproducts: data });
    }
    componentDidMount() {
        this.setRow(this.state.rowTable);
    }
    _cellButton(cell, row, enumObject, rowIndex) {
        var btn = this.state.tableproducts[rowIndex].Btn;
        var btnShow = "";
        switch (btn) {
            case 1: btnShow = <i class="fas fa-sort-down icon_down" onClick={this.switch_PopUpItem}></i>; break;
            default: btnShow = <i class=""></i>; break;
        }
        return (<div>{btnShow}</div>);
    } _cellButtonnameproduct(cell, row, enumObject, rowIndex) {
        var btn = this.state.tableproducts[rowIndex].BtnnameProduct;
        var btnShow = "";
        switch (btn) {
            case 1: btnShow = <i class="fas fa-sort-down icon_down" onClick={this.switch_PopUpItem}></i>; break;
            default: btnShow = <i class=""></i>; break;
        }
        return (<div>{btnShow}</div>);
    }

    SelectSetData = (type, data) => {
        switch (type) {
            case "productsset_c":
                // console.log(data);
                this.setState({ typeset: this._spritData(data)[0] });
                this.refs.typeset.value = this._spritData(data)[1];
                break;
            default: break;
        }
    }

    /*----------------------------------------------------------------------------------------------------------------------------*/
    switch_PopUpItem = () => {
        this.setState({ switchPopUpItem: !this.state.switchPopUpItem });
    }
    Switch_PopupArcode = (e) => {
        this.setState({ SwitchPopupArcode: !this.state.SwitchPopupArcode });
    }
    Switch_OtherPopup = (type) => {
        this.setState({ OtPopupType: type })
        this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
    }
    //********************************************************* */
    Get_PopUpItem = (data) => {

        // console.log(this.state.rowChk);
        // console.log("col"+this.state.colChk);

        let colName = "";
        if (this.state.colChk === "1") {
            colName = "C1";
        } else if (this.state.colChk === "3") {
            colName = "C2";
        }
        setTimeout(() => {
            this._addData(data, this.state.rowChk - 1, colName);
        }, 50);

    }

    //**************************************************************************popup**************************************************************************************/
    SetPopup = (data) => {
        this.setState({ PopUpTYpe: data });
        this.setState({ showPopupOT: !this.state.showPopupOT });
        //  console.log(data); 
    }
    Get_PopUpOther = (data) => {
        switch (this.state.PopUpTYpe) {
            case "searchProduct":
                this.setState({ searchProducttoDB: this._spritData(data)[0] });
                this.setState({ searchProduct: this._spritData(data)[1] });
                let arrData = this.state.tableproducts;

                var j = this.state.rowintable;
                for (var i = this.state.tableproducts.length - 1; i >= 0; i--) {// หาจากล่างขึ้นบน
                    if (!this.state.tableproducts[i].C1) {
                        j = i;
                    }
                    // else if(ItemCode===this.state.tableData_w[i].C1){
                    //     j = i;
                    // }
                }//หา แถวที่ว่างบนสุดใน products Table 
                arrData[j].C1 = this._spritData(data)[0];
                arrData[j].C2 = this._spritData(data)[1];
                arrData[j].C3 = this._spritData(data)[2];

                // arrData[j].C4 = '0',
                //     arrData[j].C5 = '0',
                //     arrData[j].C6 = '0',
                //     arrData[j].C7 = '0',
                arrData[this.state.rowChk - 1].Btn = 2;
                this.setState({ tableproducts: arrData });
                break;
            default: break;
        }
        this.setState({ showPopupOT: !this.state.showPopupOT });
        setTimeout(() => { this.props.Getdata("dataproducts", this.state); }, 50);
    }
    PopUpOtherClose = (data) => {
        this.setState({ showPopupOT: !this.state.showPopupOT });
    }

    _spritData(data) {
        var str = data.split("|");
        return str;
    }
    onRowClick = (row, col) => {
        if (col === 1) {
            this.setState({
                rowChk: row['C0']
            });
            setTimeout(() => {
                if (this.state.rowChk === "1") {
                    this.setState({
                        colChk: col
                    });
                }
                var dataArray = this.state.tableproducts;
                let tableRow = dataArray.length;
                let i;
                for (i = 0; i <= tableRow; i++) {
                    try {
                        dataArray[i].Btn = 2;
                        dataArray[i].BtnnameProduct = 2;
                    } catch (error) {
                        console.log(error);
                    }
                }
                dataArray[this.state.rowChk - 1].Btn = 1;
                this.setState({
                    tableproducts: dataArray
                });
            }, 30);
        } else if (col === 3) {
            this.setState({
                rowChk: row['C0']
            });
            setTimeout(() => {
                if (this.state.rowChk === "1") {
                    this.setState({
                        colChk: col
                    });
                }
                var dataArray = this.state.tableproducts;
                let tableRow = dataArray.length;
                let i;
                for (i = 0; i <= tableRow; i++) {
                    try {
                        dataArray[i].BtnnameProduct = 2;
                        dataArray[i].Btn = 2;
                    } catch (error) {
                        console.log(error);
                    }
                }
                dataArray[this.state.rowChk - 1].BtnnameProduct = 1;
                this.setState({
                    tableproducts: dataArray
                });
            }, 30);
        } else {
            this.setState({
                rowChk: row['C0']
            });
            var dataArray = this.state.tableproducts;
            try {
                dataArray[this.state.rowChk - 1].Btn = 2;
                dataArray[this.state.rowChk - 1].BtnnameProduct = 2;
            } catch (err) {
                console.log(err);
            }
            this.setState({
                tableproducts: dataArray
            });
        }
        setTimeout(() => {
            this.props.Getdata("dataproducts", this.state);
        }, 50);
    }
    _addrow = () => {
        // let row = this.state.rowTable; 
        // this.setState((this.state.rowTable)+1);
    }

    //------------------------------เช็คหลังกรอก-------------------------------------------------------------
    afterSaveCell = (row, cellName, cellValue) => {
        // do your stuff...  

        setTimeout(() => { this.props.Getdata("dataproducts", this.state); }, 50);
        if (cellName === "C1" || cellName === "C2") {
            if (cellValue.length > 0) {
                this._addData(cellValue, row, cellName);
            } else {
                let col = this.state.tableproducts;
                col[row.C0 - 1].C1 = "";
                col[row.C0 - 1].C2 = "";
                col[row.C0 - 1].C3 = "";
                col[row.C0 - 1].C4 = "";
                col[row.C0 - 1].C5 = "";
                col[row.C0 - 1].C6 = "";
                col[row.C0 - 1].C7 = "";
                this.setState({ tableproducts: col });
            }

            setTimeout(() => {
                this._chkrowData(row, cellName, cellValue);
            }, 80);
        }
    }
    _addData = (ItemCode, row, cellName) => {
        var url = ""
        switch (cellName) {
            case "C1":
                url = "CSPRODUCT/Code?code=" + ItemCode + "&user=" + ItemCode;
                let col = this.state.tableproducts;
                OnGetJson(url).then(data => {
                    // console.log(data);
                    var j = this.state.rowintable;
                    for (var i = this.state.tableproducts.length - 1; i >= 0; i--) {// หาจากล่างขึ้นบน
                        if (!this.state.tableproducts[i].C1) {
                            j = i;
                        } else if (ItemCode === this.state.tableproducts[i].C1) {
                            j = i;
                        }
                    }//หา แถวที่ว่างบนสุดใน products Table
                    if (data.length > 0) {
                        try {
                            col[row.C0 - 1].C1 = "";
                        } catch (error) {
                            console.log(error);
                        }
                        // try {
                        for (let i = 0; i <= data.length; i++) { //เพิ่มขอมูลทั้งหมด ลง products Table 
                            // if(data[i].CODE===this.state.tableproducts[i].C1){
                            //     j = i;
                            // } 
                            // this.setState({wherehosesearch:})
                            if (i < 1) {
                                col[j] = {
                                    C0: this.state.tableproducts[j].C0,
                                    C1: data[i].CODE,
                                    C2: data[i].NAMETH,
                                    C3: data[i].STOCKUNIT,
                                    C4: '0',
                                    C5: '0',
                                    C6: '0',
                                    C7: '0',
                                }
                            }
                            j++;
                        }
                        // } catch (error) {
                        //     console.log(error);

                        // }
                    } else {
                        col[row.C0 - 1].C1 = "";
                        col[row.C0 - 1].C2 = "";
                        col[row.C0 - 1].C3 = "";
                        col[row.C0 - 1].C4 = "";
                        col[row.C0 - 1].C5 = "";
                        col[row.C0 - 1].C6 = "";
                        col[row.C0 - 1].C7 = "";
                        AlertPopup("Error", "ไม่พบข้อมุล!");
                    }
                    this.setState({ tableproducts: col });
                });
                break;

            case "C2":
                url = "/CSPRODUCT/Name?name=" + ItemCode + "&user=" + ItemCode;
                let col_C2 = this.state.tableproducts;
                OnGetJson(url).then(data => {
                    // console.log(data);
                    var j = this.state.rowintable;
                    for (var i = this.state.tableproducts.length - 1; i >= 0; i--) {// หาจากล่างขึ้นบน
                        if (!this.state.tableproducts[i].C2) {
                            j = i;
                        } else if (ItemCode === this.state.tableproducts[i].C2) {
                            j = i;
                        }
                    }//หา แถวที่ว่างบนสุดใน products Table
                    if (data.length > 0) {
                        try {
                            col_C2[row.C0 - 1].C2 = "";
                        } catch (error) {

                        }

                        for (let i = 0; i <= data.length; i++) { //เพิ่มขอมูลทั้งหมด ลง products Table 
                            if (i < 1) {
                                col_C2[j] = {
                                    C0: this.state.tableproducts[j].C0,
                                    C1: data[i].CODE,
                                    C2: data[i].NAMETH,
                                    C3: data[i].STOCKUNIT,
                                    C4: '0',
                                    C5: '0',
                                    C6: '0',
                                    C7: '0',
                                }
                            }
                            j++;
                        }
                    } else {
                        col_C2[row.C0 - 1].C1 = "";
                        col_C2[row.C0 - 1].C2 = "";
                        col_C2[row.C0 - 1].C3 = "";
                        col_C2[row.C0 - 1].C4 = "";
                        col_C2[row.C0 - 1].C5 = "";
                        col_C2[row.C0 - 1].C6 = "";
                        col_C2[row.C0 - 1].C7 = "";
                        AlertPopup("Error", "ไม่พบข้อมุล!");
                    }
                    this.setState({ tableproducts: col_C2 });
                });
                break;
            default: break;
        }
    }
    _chkrowData = (row, cellName, cellValue) => {
        if (cellName === "C1") {
            let data_2 = this.state.tableproducts;
            for (let index = row.C0; index <= data_2.length; index++) {
                try {
                    if (data_2[index].C1 !== "") {
                        data_2[index - 1].C1 = data_2[index].C1;
                        data_2[index - 1].C2 = data_2[index].C2;
                        data_2[index - 1].C3 = data_2[index].C3;
                        data_2[index - 1].C4 = data_2[index].C4;
                        data_2[index - 1].C5 = data_2[index].C5;
                        data_2[index - 1].C6 = data_2[index].C6;
                        data_2[index - 1].C7 = data_2[index].C7;

                        data_2[index].C1 = "";
                        data_2[index].C2 = "";
                        data_2[index].C3 = "";
                        data_2[index].C4 = "";
                        data_2[index].C5 = "";
                        data_2[index].C6 = "";
                        data_2[index].C7 = "";
                    }
                } catch (error) {
                    console.log("err=>" + error);
                }
            }
            this.setState({
                tableproducts: data_2
            });
        }
    }
    render() {
        const cellEditProp = {
            mode: 'click',
            blurToSave: true,
            beforeSaveCell: this.onBeforeSaveCell,
            afterSaveCell: this.afterSaveCell,
            blurToSave: true,
        };
        const options = {
            onRowClick: this.onRowClick
        };
        return (
            <div class={this.props.Inventory.showResults === 4 ? '' : "InventoryHidden"}>
                <br></br>
                <div class="form-group unitDrop">
                    <div class="input-group ">
                        <span class="input-group-addon"> สินค้าชุด : </span>
                        <input id="productsset_c" name="productsset_c" type="text" class="form-control readonly" tabIndex="6" ref={"typeset"} readOnly />
                        <span class="input-group-addon textIcon">
                            <SelectFix type={"productsset_c"} SelectSetData={this.SelectSetData} />
                        </span>
                    </div>
                </div>

                <br></br>
                <br></br>
                {this.state.showPopupOT ? <PopUpOther closePopup={this.PopUpOtherClose} Get_PopUpOther={this.Get_PopUpOther} type={this.state.PopUpTYpe} Data={this.state.valuePopup} groupdata={this.state.grouptoDB} apikeyData={DataConfig.API_KEY[localStorage.getItem("company")]} jwtData={localStorage.getItem("Token")} /> : null}
                {this.state.switchPopUpItem ? <PopUpItem closePopup={this.switch_PopUpItem} Get_PopUpItem={this.Get_PopUpItem} /> : null}
                <div class="container" align="center">
                    <BootstrapTable
                        data={this.state.tableproducts}
                        cellEdit={cellEditProp}
                        options={options}
                        height='400'
                        headerStyle={{ borderBottom: '#BFBCBB  1px solid' }}
                    >
                        <TableHeaderColumn row='0' rowSpan='2' dataField='C0' width='40' isKey dataAlign='center'></TableHeaderColumn>
                        <TableHeaderColumn row='0' colSpan='2' width='40%' dataAlign='center' className='colbuttomhidden'>รหัสสินค้า</TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='C1' editable></TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='Btn' editable={false} width="40" dataAlign="center" dataFormat={this._cellButton.bind(this)} columnClassName='c_btn'></TableHeaderColumn>

                        <TableHeaderColumn row='0' colSpan='2' width='40%' editable dataAlign='center' className="colbuttomhidden">ชื่อสินค้า</TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='C2' editable dataAlign="center"></TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='BtnnameProduct' editable={false} width="40" dataAlign="center" dataFormat={this._cellButtonnameproduct.bind(this)} columnClassName='c_btn'></TableHeaderColumn>

                        <TableHeaderColumn row='0' rowSpan='2' dataField='C3' editable={false} dataAlign="center" width='10%'> หน่วย </TableHeaderColumn>
                        <TableHeaderColumn row='0' rowSpan='2' dataField='C4' editable dataAlign="center" width='10%'> ปริมาณ </TableHeaderColumn>
                        <TableHeaderColumn row='0' rowSpan='2' dataField='C5' editable dataAlign="center" width='10%' > ราคาขาย </TableHeaderColumn>
                        <TableHeaderColumn row='0' rowSpan='2' dataField='C6' editable dataAlign="center" width='10%' > ลด </TableHeaderColumn>
                        <TableHeaderColumn row='0' rowSpan='2' dataField='C7' editable dataAlign="center" width='10%'> จำนวนเงิน </TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        )
    }
}
